import { Prefetch, useRouteMatch } from '@features/libs';
import { affiliateBackendApiClient } from '@/api/affiliate/serv/oec_affiliate_backend_api';
var homepageTodoListPrefetch = new Prefetch(function () {
  return affiliateBackendApiClient.GetTodoList({});
}, {
  name: 'homepage_todo_list'
});
var useExecutePrefetch = function useExecutePrefetch() {
  useRouteMatch(function (match) {
    if (match.isExact) {
      // the main api for homepage, all region will use this api.
      homepageTodoListPrefetch.run();
    }
  }, ['/homepage']);
};
export { homepageTodoListPrefetch, useExecutePrefetch };